<template>
  <div class="page-component">
    <div
      class="page-component-up page-componentGl"
      id="returnTop"></div>
    <div
      class="page-component-bottom page-componentGl"
      id="returnDown"></div>
  </div>
</template>
<script>
export default {

};
</script>
<style scoped>
  .page-component .page-component-up.fadeComponentUp {
    background: url(../../assets/ui2020/icon-right-movetop2.png) no-repeat center;
    background-size: 100%;
  }
  .page-component .page-component-bottom.fadeComponentDown {
    background: url(../../assets/ui2020/icon-right-movedown2.png) no-repeat center;
    background-size: 100%;
  }
  .page-component .page-component-up {
    bottom: 215px;
    background: url(../../assets/ui2020/icon-right-movetop.png) no-repeat center;
    background-size: 100%;
  }
  .page-component .page-component-bottom {
    bottom: 168px;
    background: url(../../assets/ui2020/icon-right-movedown.png) no-repeat center;
    background-size: 100%;
  }
  .page-component .page-componentGl {
    display: block;
    background-color: #58b7ff;
    position: fixed;
    width: 40px;
    height: 40px;
    right: 64px;
    border-radius: 25px;
    cursor: pointer;
    opacity: 0.7;
    transition: .3s;
    z-index: 4;
  }
</style>
